import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Button as AriaButton } from "react-aria-components";
import { base, icon } from "./LegacyButton.css.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BaseButton = (t0, ref) => {
  const $ = _c(16);
  let Icon;
  let children;
  let props;
  let variant;
  if ($[0] !== t0) {
    ({
      variant,
      icon: Icon,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = Icon;
    $[2] = children;
    $[3] = props;
    $[4] = variant;
  } else {
    Icon = $[1];
    children = $[2];
    props = $[3];
    variant = $[4];
  }
  const iconOnly = Icon !== undefined && children == null;
  const t1 = props.isDisabled === true ? "disabled" : variant;
  let t2;
  if ($[5] !== iconOnly || $[6] !== t1) {
    t2 = base({
      button: t1,
      iconOnly
    });
    $[5] = iconOnly;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== Icon) {
    t3 = Icon && /*#__PURE__*/_jsx(Icon, {
      className: icon
    });
    $[8] = Icon;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== children || $[11] !== props || $[12] !== ref || $[13] !== t2 || $[14] !== t3) {
    t4 = /*#__PURE__*/_jsxs(AriaButton, {
      ref: ref,
      ...props,
      className: t2,
      children: [t3, children]
    });
    $[10] = children;
    $[11] = props;
    $[12] = ref;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};

/***
 * Primary UI component for user interaction
 */
export const LegacyButton = /*#__PURE__*/React.forwardRef(BaseButton);
//# sourceMappingURL=LegacyButton.js.map